import cn from 'classnames';
import { FC, useEffect } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useGeolocationIp } from 'hooks/useGeolocationIp';
import { getCountryInfoFromCode } from '../country-input/country-and-phone-code-utils';
import './styles.less';
import { isNil } from 'lodash';

export interface IMobileNumberInputValue {
  ext?: string;
  number?: string | number;
}
export interface IMobileNumberInputProps {
  value?: IMobileNumberInputValue;
  onChange?: (value: IMobileNumberInputValue) => void;
  numberPlaceholder?: string;
  inputClassName?: string;
  disabled?: boolean;
  typeMode?: 'string' | 'number';
}

export const MobileNumberInput: FC<IMobileNumberInputProps> = (props) => {
  const {
    numberPlaceholder = 'Enter phone number',
    value,
    onChange,
    inputClassName = '',
    disabled,
    typeMode = 'string',
  } = props;
  const geo = useGeolocationIp();

  useEffect(() => {
    if (geo?.country && !value?.ext) {
      const country = getCountryInfoFromCode(geo.country);
      onChange?.({ ext: country.dial_code });
    }
  }, [geo]);

  const inputValue = `${(value?.ext ?? '')?.replace('+', '')}${value?.number ?? ''}` || null;

  const handleChange = (phone: string, country: { dialCode: string }) => {
    let ext: string | undefined;
    let number: string | number | undefined;
    if (country?.dialCode && phone?.length < country?.dialCode?.length) {
      // clear country once user hit backspace dial code
      ext = undefined;
      number = undefined;
    } else {
      ext = country?.dialCode ? `+${country?.dialCode}` : undefined;
      number = !isNil(phone) && phone !== '' ? `+${phone}`.replace(ext || '', '') : phone;
    }

    if (number && typeMode === 'number') {
      number = parseInt(number, 10);
    }
    onChange?.({ ext, number });
  };

  return (
    <PhoneInput
      containerClass={cn('ant-input mobile-number-input-container', inputClassName)}
      inputClass="mobile-number-input ant-input"
      buttonClass="mobile-number-button"
      dropdownClass="mobile-number-dropdown"
      value={inputValue}
      onChange={handleChange}
      placeholder={numberPlaceholder}
      searchPlaceholder="Search country"
      enableSearch
      disabled={disabled}
    />
  );
};
